import { Dropdown } from '@quintoandar-tokko/jopijs';
import React from 'react';
import style from './radioButtonsGroup.module.scss';

function ListGroup({ list, onClickItem, ...rest }) {
  return (
    <Dropdown className={style.dropdownListGroup} {...rest}>
      <Dropdown.Button
        variant="dropdownOutlined"
        text={list.find((item) => item.checked)?.text || 'Select'}
        filled={false}
        className={style.dropdownButton}
      />
      <Dropdown.Items clickClose>
        {list.map((item) => (
          <Dropdown.Default key={item.id} onClick={() => onClickItem(item)}>
            {item.text}
          </Dropdown.Default>
        ))}
      </Dropdown.Items>
    </Dropdown>
  );
}

export default ListGroup;
